import I18n from "../../../../i18n";

const days = {
  mo: I18n.t("setup.schedules.days.mo"),
  tu: I18n.t("setup.schedules.days.tu"),
  we: I18n.t("setup.schedules.days.we"),
  th: I18n.t("setup.schedules.days.th"),
  fr: I18n.t("setup.schedules.days.fr"),
  sa: I18n.t("setup.schedules.days.sa"),
  su: I18n.t("setup.schedules.days.su"),
};

export default days;
